<script>
	import {createEventDispatcher, onMount} from 'svelte';
	import {push, replace} from 'svelte-spa-router';
	import {
		API,
		cabecalhoPadraoRequisicao,
		limparLocalStorage,
		StatusHttp,
		TextoFeedback,
		TipoEvento,
		verificarLocalStorage,
		verificarSessionStorage
	} from '../../utils';
	import PainelBox from '../templates/PainelBox.svelte';

	// The params prop contains values matched from the URL
	export let params = {}

	const dispatch = createEventDispatcher();
	let tiposBusca = {};
	let termoBusca;
	let tipoBuscaSelecionado;
	let endpointBusca;
	let desabilitarBotaoSubmit = true;

	onMount(async () => {
		if (verificarSessionStorage('AVAL_TOKEN') == false || verificarLocalStorage('AVAL_USUARIO_DADOS') == false) {
			
			limparLocalStorage(true, false, false, false);

			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Aviso',
				conteudo: 'Necessário realizar login.'
			});

			setTimeout( () => replace('/login'), 1000);
		}

		if (params.tipo == 'usuario') {
			tiposBusca = {
				NOME: "Nome",
				EMAIL: "E-mail",
				CPF: "CPF",
				MATRICULA: "Matrícula"
			};

			endpointBusca = API('usuarios/busca');
		} else if (params.tipo == 'projeto') {
			tiposBusca = {
				TITULO: "Titulo",
				CODIGO: "Código"
			};
			endpointBusca = API('projetos/busca');
		} else {
			replace('#/tipo-de-busca-nao-suportada');
		}

		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	});	

	async function submeterFormulario(event) {
		dispatch('routeEvent', {
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: true,
			mensagem: 'Buscando ...',
		});
			
		// faz a chamada a API no endpoint cadastrar, envia os dados e aguarda a resposta
		const resposta = await fetch(endpointBusca, {
			method: 'POST',
			headers: cabecalhoPadraoRequisicao(),
			body: JSON.stringify({
				campo: tipoBuscaSelecionado, 
				termo: termoBusca
			})
		}).catch(erros => {
			console.log(erros);

			dispatch('routeEvent', { 
				tipo: TipoEvento.ESTA_CARREGANDO,
				valor: false
			});
			
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro no servidor',
				conteudo: TextoFeedback.ERRO_REQUISICAO
			});
		});

		// pega o json do retorno da resposta
		const json = await resposta.json();
		
		if (resposta.status == StatusHttp.OK) {		
			if (params.tipo == 'usuario') {
				localStorage.setItem('AVAL_LISTAGEM_USUARIOS_CACHE_PG9999', JSON.stringify({ json: json }));
				setTimeout( () => push("#/usuario/resultado/busca"), 300);
			} else {
				localStorage.setItem('AVAL_LISTAGEM_PROJETOS_CACHE_PG9999', JSON.stringify({ json: json }));
				setTimeout( () => push("#/projeto/resultado/busca"), 300);
			}
		} else {
			dispatch('routeEvent', {
				tipo: TipoEvento.ABRIR_MODAL,
				titulo: 'Erro...',
				conteudo: json?.mensagem
			});
		}

		dispatch('routeEvent', { 
			tipo: TipoEvento.ESTA_CARREGANDO,
			valor: false
		});
	}

	const alterarStatusSubmit = (evento) => {
		if (tipoBuscaSelecionado == null)
			desabilitarBotaoSubmit = true;
		else
			desabilitarBotaoSubmit = false;
	}
</script>

<PainelBox 
	largura="12" 
	deslocamento="0"
	titulo="Painel de Busca">

	<form method="post" on:submit|preventDefault={submeterFormulario}>
		<div class="columns">
			<div class="column is-3">
				<div class="select is-primary is-large is-fullwidth">
					<select bind:value={tipoBuscaSelecionado} name="tipo_busca" on:blur={alterarStatusSubmit} required>
						<option value="{null}">Tipo...</option>
						{#each Object.entries(tiposBusca) as [chave, valor]}
						<option value="{chave}">{valor}</option>
						{/each}
					</select>
				</div>
			</div>
			
			<div class="column is-6">
				<div class="field">
					<input 
						bind:value={termoBusca}
						name="termo_busca" 
						type="text" 
						placeholder="Digite aqui o que você procura" 
						class="input is-large is-primary is-fullwidth" required>
				</div>
			</div>

			<div class="column is-3">
				<div class="field">
					<button 
						type="submit" 
						disabled="{desabilitarBotaoSubmit}" 
						class="button is-primary is-large is-fullwidth">
						Buscar
					</button>
				</div>
			</div>
		</div>
	</form>
</PainelBox>
